import { Grid, Skeleton } from "@mui/material";
import React from "react";

const SuppliersCardSkeleton = () => {
  return (
    <>
      <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
        <Skeleton animation="wave" height={170} width={"100%"} />
      </Grid>
    </>
  );
};

export default SuppliersCardSkeleton;
